export default __webpack_public_path__ + "static/media/Hauberk of Swiftstriking.49f9b1fb.jpg";